import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkActionsBar = ({ selectedCount, onBulkAction, onClearSelection }) => {
  const [showConfirmation, setShowConfirmation] = useState(null);

  if (selectedCount === 0) return null;

  const handleBulkAction = (action) => {
    if (action === 'delete' || action === 'archive') {
      setShowConfirmation(action);
    } else {
      onBulkAction(action);
    }
  };

  const confirmAction = () => {
    onBulkAction(showConfirmation);
    setShowConfirmation(null);
  };

  const cancelAction = () => {
    setShowConfirmation(null);
  };

  const bulkActions = [
    {
      id: 'export',
      label: 'Exportar',
      icon: 'Download',
      variant: 'secondary'
    },
    {
      id: 'update-price',
      label: 'Actualizar Precios',
      icon: 'DollarSign',
      variant: 'secondary'
    },
    {
      id: 'update-stock',
      label: 'Ajustar Stock',
      icon: 'Package',
      variant: 'secondary'
    },
    {
      id: 'change-category',
      label: 'Cambiar Categoría',
      icon: 'Tag',
      variant: 'secondary'
    },
    {
      id: 'archive',
      label: 'Archivar',
      icon: 'Archive',
      variant: 'warning'
    }
  ];

  return (
    <>
      <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 bg-surface rounded-lg shadow-floating border border-border p-4 z-floating">
        <div className="flex items-center space-x-4">
          {/* Selection Info */}
          <div className="flex items-center space-x-2">
            <Icon name="CheckSquare" size={20} className="text-primary" />
            <span className="text-sm font-body-medium text-text-primary">
              {selectedCount} producto{selectedCount !== 1 ? 's' : ''} seleccionado{selectedCount !== 1 ? 's' : ''}
            </span>
          </div>

          {/* Divider */}
          <div className="w-px h-6 bg-border"></div>

          {/* Actions */}
          <div className="flex items-center space-x-2">
            {bulkActions.map((action) => (
              <Button
                key={action.id}
                variant={action.variant}
                size="sm"
                onClick={() => handleBulkAction(action.id)}
                iconName={action.icon}
                iconSize={16}
              >
                {action.label}
              </Button>
            ))}
          </div>

          {/* Clear Selection */}
          <button
            onClick={onClearSelection}
            className="p-2 hover:bg-secondary-100 rounded-md transition-micro"
            title="Limpiar selección"
          >
            <Icon name="X" size={16} className="text-text-muted" />
          </button>
        </div>
      </div>

      {/* Confirmation Modal */}
      {showConfirmation && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-modal">
          <div className="bg-surface rounded-lg shadow-modal border border-border p-6 max-w-md w-full mx-4">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-12 h-12 rounded-full bg-warning-100 flex items-center justify-center">
                <Icon name="AlertTriangle" size={24} className="text-warning" />
              </div>
              <div>
                <h3 className="text-lg font-body-medium text-text-primary">
                  Confirmar acción
                </h3>
                <p className="text-sm text-text-muted">
                  Esta acción no se puede deshacer
                </p>
              </div>
            </div>

            <p className="text-sm text-text-secondary mb-6">
              ¿Estás seguro de que quieres {showConfirmation === 'archive' ? 'archivar' : 'eliminar'} {selectedCount} producto{selectedCount !== 1 ? 's' : ''}?
            </p>

            <div className="flex items-center justify-end space-x-3">
              <Button variant="ghost" onClick={cancelAction}>
                Cancelar
              </Button>
              <Button 
                variant={showConfirmation === 'archive' ? 'warning' : 'danger'} 
                onClick={confirmAction}
              >
                {showConfirmation === 'archive' ? 'Archivar' : 'Eliminar'}
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default BulkActionsBar;